import CustomDropdown from '../AdminReportComponents/CustomDropdown/CustomDropdown';
import { getListOfSchoolYears } from '../reportUtilities';
import styles from './SchoolYearSelector.module.scss';

interface SchoolYearSelectorProps {
  selectedSchoolYear: string;
  // eslint-disable-next-line no-unused-vars
  onSelectSchoolYear: (_selectedSchoolYear: string) => void;
  disabled?: boolean;
}

const SchoolYearSelector = ({
  selectedSchoolYear,
  onSelectSchoolYear,
  disabled = false,
}: SchoolYearSelectorProps): JSX.Element => {
  const schoolYears = getListOfSchoolYears();
  const fallbackSchoolYearId = selectedSchoolYear || schoolYears[0]?.id || '';

  return (
    <div className={styles.schoolYearSelector}>
      <label className={styles.label}>School Year:</label>
      <div className={styles.dropdownContainer}>
        <CustomDropdown
          noFilter
          list={schoolYears}
          onSelectSubject={(eventKey) => onSelectSchoolYear(eventKey || '')}
          initialValue={fallbackSchoolYearId}
          currentlySelectedItem={selectedSchoolYear}
          disableChangeLocation={disabled}
          icon='akar-icons:calendar'
          placeholder='Select School Year'
        />
      </div>
    </div>
  );
};

export default SchoolYearSelector;
